export default __webpack_public_path__ + "static/media/Mark-6-HUD-Pop-Up (Process) 4in1.ec0dab5c.jpg";